export default (BaseClass, dataStore) =>
	class extends BaseClass {
		/**
		 * Listen to changes in the data store once the widget is rendered.
		 */
		connectedCallback() {
			if (typeof super.connectedCallback === "function") {
				super.connectedCallback();
			}
			this.update(dataStore.getState(), dataStore);
			dataStore.subscribe(this.update.bind(this));
		}

		/**
		 * Dispatches an action to the store.
		 *
		 * @param {function} action
		 * @param {mixed} payload
		 * @return {Promise}
		 */
		dispatchAction(action, payload) {
			return dataStore.dispatch(action, payload);
		}

		/**
		 * Will be called when the data changes.
		 */
		update(/*state, dataStore*/) {}
	};
